import React from 'react';
import { FileBrowser } from 'components/FileBrowser/FileBrowser';
import { FileManager } from 'components/FileManager/FileManager';

export function TransceiversView() {
    return (
        <div className="main_views_cont">
            <div className="main_view_left_cont"></div>
            <div className="main_view_center_cont">
                <FileBrowser />
            </div>
            <div className="main_view_right_cont">
                <FileManager />
            </div>
        </div>
    );
}
